import { createStaticPropsGetter,Page } from "../libs/pages";

export const getStaticProps = createStaticPropsGetter("qui-sommes-nous");

export default Page;
